import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import { DayEnum } from '@api/ringil-api.v2.tsx';

export interface ShiftOption {
  days: number;
  label: string;
  testId: string;
}

export interface WeekDayOption {
  day: DayEnum;
  label: string;
  testId: string;
}

/**
 * Offsets and weekdays offered by the duplication date pickers (expedition duplication and timeslot
 * duplication share the same list). Labels differ a lot in length between languages
 * (cs "Neděle" vs de "Sonntag" vs pl "Niedziela"), so the rows rendering them have to wrap.
 */
export const useDuplicateDateOptions = (): { shiftOptions: ShiftOption[]; weekDayOptions: WeekDayOption[] } => {
  const { tr } = useTranslationLgs();

  return {
    shiftOptions: [
      { days: 1, label: tr(`duplicate.1Den`, `1 den`), testId: '1day' },
      { days: 7, label: tr(`duplicate.7Dnu`, `7 dnu`), testId: '7days' },
      { days: 14, label: tr(`duplicate.14Dni`, `14 dni`), testId: '14days' },
      { days: 21, label: tr(`duplicate.21Dnu`, `21 dnu`), testId: '21days' },
      { days: 30, label: tr(`duplicate.30Dni`, `30 dni`), testId: '30days' },
    ],
    weekDayOptions: [
      { day: DayEnum.MONDAY, label: tr(`duplicate.nextMonday`, `Pristi pondeli`), testId: 'monday' },
      { day: DayEnum.TUESDAY, label: tr(`duplicate.tuesday`, `Utery`), testId: 'tuesday' },
      { day: DayEnum.WEDNESDAY, label: tr(`duplicate.wednesday`, `Streda`), testId: 'wednesday' },
      { day: DayEnum.THURSDAY, label: tr(`duplicate.thursday`, `Ctvrtek`), testId: 'thursday' },
      { day: DayEnum.FRIDAY, label: tr(`duplicate.friday`, `Patek`), testId: 'friday' },
      { day: DayEnum.SATURDAY, label: tr(`duplicate.saturday`, `Sobota`), testId: 'saturday' },
      { day: DayEnum.SUNDAY, label: tr(`duplicate.sunday`, `Nedele`), testId: 'sunday' },
    ],
  };
};
